export default "__VITE_ASSET__CSvAvphR__"